var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "mb-0 section", attrs: { id: "PerProfessional" } },
    [
      _c("covid-notice"),
      _vm._v(" "),
      _c(
        "transition",
        { attrs: { name: "fade", mode: "out-in" } },
        [
          _c("search-professionals", {
            class: { "passed-on": _vm.professional },
            attrs: { id: "search_professionals", address: _vm.address }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "transition",
        { attrs: { name: "fade", mode: "out-in" } },
        [
          _vm.professionals_available
            ? _c("professionals", {
                class: { "passed-on": _vm.professional },
                attrs: { searchInput: false },
                on: {
                  professionalSelected: function($event) {
                    _vm.scrollTo("#events")
                  }
                }
              })
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "transition",
        { attrs: { name: "fade", mode: "out-in" } },
        [
          _vm.professional
            ? _c("available-events", {
                class: { "passed-on": _vm.ends_at },
                attrs: {
                  id: "events",
                  selectedEvent: _vm.event,
                  professional: _vm.professional
                },
                on: { eventSelected: _vm.selectEvent }
              })
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "transition",
        { attrs: { name: "fade", mode: "out-in" } },
        [
          _vm.event
            ? _c("time-picker", {
                class: { "passed-on": _vm.ends_at },
                attrs: {
                  id: "time-picker",
                  title: "SELECIONE A HORA INICIAL E FINAL",
                  isToday: _vm.isToday,
                  initialHour: _vm.getHourOfDate(_vm.event.starts_at),
                  finalHour: _vm.getHourOfDate(_vm.event.ends_at),
                  startsAt: parseInt(_vm.starts_at),
                  endsAt: parseInt(_vm.ends_at)
                },
                on: {
                  startSelected: _vm.selectStartsAt,
                  endSelected: _vm.selectEndsAt
                }
              })
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "transition",
        { attrs: { name: "fade", mode: "out-in" } },
        [
          _vm.price
            ? _c("confirm-period-and-price", {
                class: { "passed-on": _vm.additional_informations },
                attrs: { id: "confirm-period-and-price" },
                on: {
                  scrollTo: function($event) {
                    _vm.$emit("scrollTo", $event)
                  }
                }
              })
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0796e9b4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0796e9b4","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PurchaseFlow/PerProfessional.vue
// module id = null
// module chunks = 